import { Outlet } from 'react-router-dom';

export default function Devices() {
  return (
    <>
      <Outlet />
    </>
  );
}
